<template>
    <v-card @click="$emit('click')"  class="kim-card outlined hover" >
        <v-card-title class="pb-1">
                <v-list-item  class="text-truncate">

                    <v-list-item-avatar>
                        <img :src="client && client.avatar || getFakeAvatar(client.gender)">
                    </v-list-item-avatar>

                    <v-list-item-content>

                        <v-list-item-title>
                            {{client.first_name}} {{client.last_name}}
                        </v-list-item-title>
                        <v-list-item-subtitle>
                            {{client.dni | rut}}
                        </v-list-item-subtitle>

                    </v-list-item-content>

                </v-list-item>
        </v-card-title>
        <v-card-text class="pt-0 px-4 text-left text-truncate">
            <div class="caption py-1">
                <v-icon size="13" color="primary" >fa-envelope</v-icon> {{client.email || 'n/d'}}
            </div>
            <div class="caption">
                <v-icon size="14" color="primary" >fa-phone-square</v-icon> {{client.phone1 ? `+56${client.phone1}` : 'n/d'}}
            </div>
        </v-card-text>
    </v-card>
</template>

<script>
    import {getFakeAvatar} from "../../utils/Common";

    export default {
        name: "ClientCard",
        props:{
            client:{
                type: Object,
                required: true
            }
        },
        methods:{
            getFakeAvatar
        }
    }
</script>

<style scoped>

</style>
